// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicMetricsState = {
  ...DefaultState
}

export const topicMetrics = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicMetricsState,
  actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_METRICS,
  actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_METRICS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_METRICS,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_PLAN_METRICS
})
